/*
  Sibling colours in place (landing pages).

  A "Product form" section in collection mode renders one buy box per sibling colour
  (or a page carries one section per colour), each flagged with data-siblings-inplace. Clicking a colour swatch reveals the matching section instead
  of navigating to that colour's product page. Without JS the swatches keep working as
  normal links, so nothing depends on this file.

  Deep-link a colour with ?colour=<product-handle> (or ?color=).
*/
(function () {
  if (window.DRSiblingsInplace) return;
  window.DRSiblingsInplace = true;

  var SECTION = '[data-section-type="product"][data-siblings-inplace]';
  var HIDDEN_CLASS = 'siblings-inplace--hidden';
  var READY_CLASS = 'siblings-inplace-ready';
  var PARAMS = ['colour', 'color'];

  function sections() {
    return Array.prototype.slice.call(document.querySelectorAll(SECTION));
  }

  function byHandle(list, handle) {
    return list.filter(function (section) {
      return handle && section.getAttribute('data-product-handle') === handle;
    })[0];
  }

  // Each colour's theme form must carry its own variant. KaChing rewrites the hidden
  // variant input of the form next to its widget, so pin it back after every change.
  function pinVariant(section) {
    var id = section.getAttribute('data-variant-id');
    if (!id) return;
    section.querySelectorAll('.product-page form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
      if (input.value !== id) input.value = id;
    });
  }

  // Only the visible colour keeps a live KaChing widget: with several widgets on the
  // page KaChing binds every theme form to the last product it initialised.
  function syncKaching(target, list) {
    var changed = false;
    list.forEach(function (section) {
      if (section === target) return;
      section.querySelectorAll('kaching-bundle').forEach(function (widget) {
        widget.remove();
        changed = true;
      });
    });
    var slot = target.querySelector('[data-kaching-slot]');
    if (slot && !slot.querySelector('kaching-bundle')) {
      var widget = document.createElement('kaching-bundle');
      widget.setAttribute('product-id', slot.getAttribute('data-product-id'));
      widget.setAttribute('manual-deal-block-id', slot.getAttribute('data-manual-deal-block-id') || '');
      slot.appendChild(widget);
      changed = true;
    }
    if (changed && typeof window.kachingBundlesInitialize === 'function') {
      window.kachingBundlesInitialize();
    }
    pinVariant(target);
    // KaChing initialises asynchronously; pin again once it has had a chance to write.
    setTimeout(function () { pinVariant(target); }, 1500);
    setTimeout(function () { pinVariant(target); }, 4000);
  }

  function reveal(target, list) {
    list.forEach(function (section) {
      section.classList.toggle(HIDDEN_CLASS, section !== target);
    });
    syncKaching(target, list);
    // Sliders measured while hidden have no width; let them lay out again now they're visible.
    window.dispatchEvent(new Event('resize'));
  }

  function show(handle) {
    var list = sections();
    var target = byHandle(list, handle);
    if (!target) return false;
    reveal(target, list);
    return true;
  }

  function initial() {
    var list = sections();
    if (!list.length) return;
    var params = new URLSearchParams(window.location.search);
    var wanted = PARAMS.map(function (key) { return params.get(key); }).filter(Boolean)[0];
    reveal(byHandle(list, wanted) || list[0], list);
    document.documentElement.classList.add(READY_CLASS);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('a.siblings__link[data-sibling-handle]');
    if (!link || !link.closest(SECTION)) return;
    if (show(link.getAttribute('data-sibling-handle'))) {
      event.preventDefault();
    }
  });

  // Theme editor: reveal the section the merchant is editing.
  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target && event.target.querySelector(SECTION);
    if (section) reveal(section, sections());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initial);
  } else {
    initial();
  }
})();
